export enum AppName {
  FANDUEL_CASINO = 'fanduel-casino',
  STARDUST_CASINO = 'stardust-casino',
  MOHEGANSUN_CASINO = 'mohegansun-casino',
}
